import { cn } from "@/core/helpers/cn";

type Props = {
  className?: string;
  onClick: () => void;
  label: string;
  isActive: boolean;
};

export default function SpawnNavigateButton({ className, label, onClick, isActive }: Props) {
  return (
    <button
      type="button"
      className={cn(
        "h-[2.625rem] rounded-[0.5rem] flex items-center bg-dark-900/80 px-[1rem] shrink-0 cursor-pointer",
        "text-12 font-extrabold uppercase",
        { "brightness-140": isActive },
        className,
      )}
      onClick={onClick}
    >
      {label}
    </button>
  );
}
